import EmLocator from './modules/EmLocator';

export const initLocator = (locatorEl) => {
	const key = locatorEl.id.replace('js-eml-locator-', '');
	window.emlLocators[key] = new EmLocator(locatorEl);
};

export const initLocators = () => {
	window.emlLocators = [];
	const locatorEls = [...document.querySelectorAll('.js-eml-locator')];
	locatorEls.forEach((locatorEl) => {
		initLocator(locatorEl);
	});
};

document.addEventListener('DOMContentLoaded', () => {
	// Initialize locators
	initLocators();

	// Handle product filter change
	const select = document.getElementById('product-filter');
	if (select) { // Check if the element exists
		select.addEventListener('change', function () {
			const selectedOption = this.options[this.selectedIndex];
			if (selectedOption.value === '') {
				this.style.color = '#a3a3a3';
			} else {
				this.style.color = '#000';
			}
		});
	}
});
